export default {"src":"/_next/static/media/Expand.c32d0cc4.svg","height":7,"width":14,"blurWidth":0,"blurHeight":0};